// extracted by mini-css-extract-plugin
export default {"loader":"MySpinner_loader__vNXDl","flip1":"MySpinner_flip1__YIoxY","flip2":"MySpinner_flip2__8kH07","flip3":"MySpinner_flip3__+VC8F"};